import { ThemeEnum } from '../enums/appEnum'

export const prefixCls = 'xingyuv'

export const multipleTabHeight = 30

export const darkMode = ThemeEnum.LIGHT

// app主题色预设
export const APP_PRESET_COLOR_LIST: string[] = [
  '#3562bc',
  '#5472ac',
  '#0084f4',
  '#009688',
  '#536dfe',
  '#ff5c93',
  '#ee4f12',
  '#0096c7',
  '#9c27b0',
  '#ff9800',
]

// 顶部背景色预设
export const HEADER_PRESET_BG_COLOR_LIST: string[] = [
  '#ffffff',
  '#001529',
  '#dbe4f6',
  '#465b72',
  '#151515',
  '#009688',
  '#5172DC',
  '#018ffb',
  '#409eff',
  '#e74c3c',
  '#24292e',
  '#394664',
  '#001529',
  '#383f45',
]

// 左侧菜单背景色预设
export const SIDE_BAR_BG_COLOR_LIST: string[] = [
  // '#486a97', 原
  '#001529',
  '#dbe4f6',
  '#ffffff',
  '#465b72',
  '#001529',
  '#212121',
  '#191b24',
  '#191a23',
  '#304156',
  '#001628',
  '#28333E',
  '#344058',
  '#383f45',
]
